<app-public-navbar></app-public-navbar> <!-- Navbar pubblica -->
<div class="public-layout">
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
<app-footer></app-footer>